import { render, staticRenderFns } from "./UserAccountStatus.vue?vue&type=template&id=3715895c"
import script from "./UserAccountStatus.vue?vue&type=script&lang=js"
export * from "./UserAccountStatus.vue?vue&type=script&lang=js"
import style0 from "./UserAccountStatus.vue?vue&type=style&index=0&id=3715895c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports